import { render } from "./DirectSupport.vue?vue&type=template&id=3ebb750b"
import script from "./DirectSupport.vue?vue&type=script&lang=js"
export * from "./DirectSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__